// Tick and combat for data-driven entities (not legacy demon stack).

import type { World } from './world';
import { getBehavior } from './behaviors/registry';
import { isLegacyBehavior } from './entity-adapter';

const tr = Math.trunc;

export function tickDataEntities(world: World, dt: number): void {
  for (const entity of world.entities.entities.values()) {
    if (entity.hp <= 0) continue;
    if (isLegacyBehavior(entity.behaviorId)) continue;
    getBehavior(entity.behaviorId)?.onTick?.(world, entity, dt);
  }
}

export function hurtDataEntities(
  world: World,
  x: number,
  y: number,
  range: number,
  power: number
): void {
  for (const entity of [...world.entities.entities.values()]) {
    if (entity.hp <= 0 || isLegacyBehavior(entity.behaviorId)) continue;
    const dx = entity.pos.x - x;
    const dy = entity.pos.y - y;
    const dist = tr(Math.sqrt(dx * dx + dy * dy));
    if (dist >= range) continue;
    const str = (entity.data.str as number) ?? entity.maxHp;
    if (power < str) continue;
    getBehavior(entity.behaviorId)?.onHit?.(world, entity, power);
    if (entity.hp <= 0) {
      getBehavior(entity.behaviorId)?.onDeath?.(world, entity);
    }
  }
}

export function clearDataEntities(world: World): void {
  world.entities.entities.clear();
  world.entities.nextId = 1;
}
